export default {"src":"/_next/static/media/swish.87f23f85.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};